module.exports = __webpack_public_path__ + "img/4.f2d9e183.jpg";